/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2021] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

import Radio from 'backbone.radio';
import NProgress from 'nprogress';

import Scaffold from '../../../Scaffold';
import GetTaskData from '../../../services/GetTaskData';
import showErrorMessage from '../../../util/showErrorMessage';

export default async function ShowTask(taskId) {
  NProgress.start();

  try {
    const taskData = await GetTaskData(taskId);
    NProgress.set(0.33);
    const formIdentifier = taskData.taskType.formIdentifier;
    const TaskBuilderPromise = Radio.channel('task').request(`build:${formIdentifier}`, taskData);
    if (!TaskBuilderPromise) {
      NProgress.done();
      showErrorMessage({
        errorCode: 'task.not.found',
        errorTitle: 'Task Type Not Found',
        errorMessage: 'The type of task being loaded could not be found in the system. Contact site administrator.',
      });
      throw new Error('Task type not found for the requested task');
    }
    const taskView = await TaskBuilderPromise;
    taskView.options.taskId = taskId;
    Scaffold.getRegion('content').show(taskView);
  } finally {
    NProgress.done();
  }
}
